
import {Form} from '$src/common/forms'
import {React} from '$src/handy'
import * as css from './Left.css'
import CheckBoxGroupInput from '$src/common/CheckBoxGroupInput'
import MultiSelectInput from '$src/common/MultiSelectInput'
import TextInput from '$src/common/TextInput'
import RangeInput from '$src/common/RangeInput'
import RadioGroupInput from '$src/common/RadioGroupInput'
import DateRangeInput from '$src/common/DateRangeInput'
import {municipalities, postalCodes, owners, sources} from '$src/hardCodedData'


interface Props {
    onSubmit: ()=>void;
    valuesMst: any;
    frozen: boolean;
    rentData: any;
}

const RentFilters = (props:Props)=>{
    const saunaOptions = [
        {value: '', label: "Doesn't matter"},
        {value: true, label: 'Yes'},
        {value: false, label: 'No'},
    ];

    const propertyOptions = [
        {value: 'apartment', label: 'Apartment'},
        {value: 'row', label: 'Row'},
    ];

    const conditionOptions = [
        {value: 'hyvä', label: 'Hyvä'},
        {value: 'tuntematon', label: 'Tuntematon'},
        {value: 'tyydyttävä', label: 'Tyydyttävä'},
        {value: 'välttävä', label: 'Välttävä'},        
    ];

    const accommodationOptions = [
        {value: 'Ei tietoa', label: 'Ei tietoa'},
        {value: 'vapaarahoitteinen', label: 'Vapaarahoitteinen'},
    ];

    return (
        <Form
            onSubmit={props.onSubmit}
            valuesMst={props.valuesMst}
            disabled={props.frozen}
        >
            <MultiSelectInput.Field
                label="Source"
                name="source"
                options={sources}
            />
            <MultiSelectInput.Field label="Owner" name="owner" options={owners} />
            <CheckBoxGroupInput.Field
                label="Property Type"
                name="propertyTypeRent"
                options={propertyOptions}
            />
            <MultiSelectInput.Field
                label="Accommodation Type"
                name="accommodationTypeRent"
                options={accommodationOptions}
            />
            <MultiSelectInput.Field
                label="Municipality"
                name="municipalityRent"
                options={municipalities}
            />
            <MultiSelectInput.Field
                label="Postal Codes"
                name="postalCodeRent"
                options={postalCodes}
            />
           <TextInput.Field
                label="Street Address"
                style="small"
                css={{input: css.textInput}}
                name="streetAddressRent"
                placeholder="Any street address"
            />
            <RangeInput.Field label="Living Area" name="livingAreaRent" />
            <RangeInput.Field label="Floor Number" name="floorNumberRent" />
            <RangeInput.Field
                label="Year of Construction"
                name="yearOfConstructionRent"
            />
            <RangeInput.Field label="Number of Rooms" name="numberOfRoomsRent" />
            <MultiSelectInput.Field
                label="Condition"
                name="conditionRent"
                options={conditionOptions}
            />
            <DateRangeInput.Field
                name="dateOfRent"
                label="Date of Rent Observation"
                tip="Write day and month with two digits,<br />e.g. 01/01/2020 instead of 1/1/2020"
            />           
            <RadioGroupInput.Field
                label="Sauna"
                name="hasSaunaRent"
                options={saunaOptions}
            />
        </Form>
    )
}

 
export default RentFilters;


// WEBPACK FOOTER //
// ./src/comparableSales/RentFilters.tsx